<script>
import { round, uniqueId } from "lodash";
import Select2 from "vue3-select2-component";

// https://www.npmjs.com/package/vue3-select2-component
// https://select2.org/
require("select2/dist/js/i18n/pt-BR.js");

$.fn.select2.defaults.set("theme", "bootstrap");
$.fn.select2.defaults.set(
  "language",
  $.fn.select2.amd.require("select2/i18n/pt-BR")
);
$.fn.select2.defaults.set("allowClear", "true");

//Fix https://github.com/select2/select2/issues/5993
$(document).on("select2:open", (e) => {
  const selectId = e.target.id;

  $(
    ".select2-search__field[aria-controls='select2-" + selectId + "-results']"
  ).each(function (key, value) {
    value.focus();
  });
});

export default {
  mixins: [Select2],
  emits: [...Select2.emits, "select"],
  props: {
    ...Select2.props,
    modelValue: {
      default: null,
      required: true,
      type: [String, Number, Array, null],
    },
    disabled: {},
  },
  watch: {
    options: {
      handler(val) {
        this.setOption(val);
      },
      deep: true,
    },
    modelValue: {
      handler(val) {
        this.setValue(val);
      },
      deep: true,
    },
    settings: {
      handler(val) {
        this.rebuildSelect2();
      },
      deep: true,
    },
  },
  methods: {
    initOptionSelectedByAjax(value, ajaxSettings) {
      const url =
        typeof ajaxSettings.url === "function"
          ? ajaxSettings.url()
          : ajaxSettings.url;

      let fullUrlSearch = "";

      if (url.includes("?")) {
        fullUrlSearch = url + "&id=" + value;
      } else {
        fullUrlSearch = url + "?id=" + value;
      }

      axios.get(fullUrlSearch).then((res) => {
        let processedData = res.data;

        if (!processedData.results) {
          processedData.results = [processedData];
        }

        if (ajaxSettings.processResults) {
          processedData = ajaxSettings.processResults(processedData);
        }

        const item = processedData.results.find((item) => item.id == value);

        if (item) {
          $(this.select2)
            .find("option[value=" + item.id + "]")
            .remove();
          var newOption = new Option(item.text, item.id, false, true);
          $(this.select2).append(newOption).trigger("change");

          $(this.select2).trigger("change");
        }
      });
    },

    setValue(val) {
      let valFindable = false;
      if (this.settings && this.settings.tags && val instanceof Array) {
        valFindable = val.length > 0;
        this.settings.tags = [...val];
        this.select2.val([...val]);
      } else if (val instanceof Array) {
        valFindable = val.length > 0;
        this.select2.val([...val]);
      } else {
        valFindable = !(val === "" || val === null);
        this.select2.val([val]);
      }

      this.select2.trigger("change");

      if (String(val) !== String(this.select2.val())) {
        //Evita reinicializar após escolher
        if (this.settings && this.settings.ajax) {
          if (valFindable) {
            if (this.ajaxControl) {
              clearTimeout(this.ajaxControl);
            }

            this.ajaxControl = setTimeout(() => {
              this.initOptionSelectedByAjax(val, this.settings.ajax);
            }, 500);
          }
        }
      }
    },

    buildSelect2() {
      const idTemp = "select2tempid-" + uniqueId();

      const $modalParent = $(this.$el).closest(".modal");

      if ($modalParent.attr("tabindex")) {
        console.warn(
          "select2#" +
          idTemp +
          " dentro de modal com tabindex pode causar falha na pesquisa."
        );
      }

      this.select2 = $(this.$el)
        .find("select")
        .attr("id", idTemp)
        .select2({
          placeholder: this.placeholder,
          ...this.settings,
          data: this.options,
        });
      this.setValue(this.modelValue);
    },
    destroySelect2() {
      try {
        if (this.select2.data("select2")) {
          this.select2.select2("destroy");
        }
      } catch (err) {
        console.warn(err);
      }
    },
    rebuildSelect2() {
      this.destroySelect2();
      this.buildSelect2();
    },
  },
  mounted() {
    this.buildSelect2();
  },
  beforeUnmount() {
    this.destroySelect2();
  },
};
</script>